/* eslint-disable no-else-return */
import React from "react"

import { XIcon } from "../../../assets/icons"
import { Chip, ChipContainer, ChipText } from "./demographicChips.styled"

export default function DemographicChips({ demographicsFilter, onRemoveFilterItem }) {
  return (
    <>
      {Object.values(demographicsFilter)?.length ? (
        <ChipContainer>
          {Object.keys(demographicsFilter).map(key => {
            if (demographicsFilter[key] && demographicsFilter[key]?.length) {
              return demographicsFilter[key].map(subItem => (
                <Chip
                  key={subItem.value}
                  width="auto"
                  borderRadius={99}
                  height={32}
                  elevation={0}
                  onClick={() => onRemoveFilterItem(subItem.value)}
                >
                  <ChipText>{subItem.label}</ChipText>
                  <XIcon />
                </Chip>
              ))
            } else if (demographicsFilter[key]?.value && demographicsFilter[key].value !== "0") {
              return (
                <Chip
                  key={demographicsFilter[key].value}
                  width="auto"
                  borderRadius={99}
                  height={32}
                  elevation={0}
                  onClick={
                    () =>
                      onRemoveFilterItem(demographicsFilter[key].value, demographicsFilter[key].label, key)
                    // eslint-disable-next-line react/jsx-curly-newline
                  }
                >
                  <ChipText>{demographicsFilter[key].label}</ChipText>
                  <XIcon />
                </Chip>
              )
            }

            return null
          })}
        </ChipContainer>
      ) : null}
    </>
  )
}
